module.exports = __webpack_public_path__ + "media/next_number_out_2.8e39bbdd.mp3";